import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    marginHorizontal: 16,
    position: 'relative',
  },
  titleAndSubtitleContainer: {
    marginTop: -24,
  },
  subheaderTitle: theme => ({
    ...Fonts.type.bold,
    fontSize: 25,
    lineHeight: 31.2,
    color: theme.colors.headerColor,
  }),
  subheaderSubtitle: theme => ({
    fontSize: 16.6,
    color: theme.colors.subtitle,
    marginVertical: 17,
  }),
});
